"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSlice = exports.invokeRequest = exports.selectCachedRequest = exports.selectOnGoingRequest = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const superagent_1 = __importDefault(require("superagent"));
const makeKey = (request) => JSON.stringify(request);
const makeUrl = (settings, url) => {
    let requestUrl = settings.API_URL;
    requestUrl += url;
    return requestUrl;
};
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
const selectOnGoingRequest = (state, key) => state.onGoingRequests[key];
exports.selectOnGoingRequest = selectOnGoingRequest;
const selectCachedRequest = (state, key) => state.requestsCache[key];
exports.selectCachedRequest = selectCachedRequest;
const createRequest = (method, url, query, data, token, options) => {
    const request = (0, superagent_1.default)(method, url);
    // Set query parameters.
    if (query !== undefined) {
        request.query(query);
    }
    // Set token if given
    if (token !== undefined) {
        request.set('Authorization', `Bearer ${token}`);
    }
    if (options.requestID !== undefined) {
        request.set('x-daisy-request-id', options.requestID);
    }
    if (data !== undefined) {
        if (options.isFormData) {
            const { files } = data;
            const formData = new FormData();
            Object.keys(files).forEach((key) => {
                if (files[key] instanceof File) {
                    formData.append('file', files[key]);
                }
            });
            request.send(formData);
        }
        else {
            request.type('json');
            request.send(data);
        }
    }
    // Check if response type should be set to blob.
    // Note that request type is always JSON and caller cannot change it.
    if (options !== undefined && options.isBlob) {
        request.responseType('blob');
    }
    return request;
};
exports.invokeRequest = (0, toolkit_1.createAsyncThunk)('request/invoke', (options, thunk) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { method, url } = options;
    const key = makeKey(options);
    const APIurl = makeUrl(thunk.extra.settingsProvider, url);
    const token = thunk.extra.sessionProvider.getToken();
    options.requestID = (_a = thunk.extra.settingsProvider) === null || _a === void 0 ? void 0 : _a.createRequestID();
    // const idToken = thunk.extra.sessionProvider.getIdToken();
    // const tenant = thunk.extra.sessionProvider.getTenant();
    try {
        const response = yield createRequest(method, APIurl, null, options.data, token, options);
        const { body, error } = response;
        return { key, body, error };
        // return !isBlob(body) ? { key, body, error } : { key, error, body: {} };
    }
    catch (err) {
        return thunk.rejectWithValue({
            key,
            error: err.message
        });
    }
}));
exports.requestSlice = (0, toolkit_1.createSlice)({
    name: 'requests',
    initialState: {
        onGoingRequests: {},
        requestsCache: {},
        requestFail: {},
        isFetching: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(exports.invokeRequest.pending, (state, action) => {
            state.onGoingRequests[action.meta.requestId] = action.meta.arg;
            state.isFetching = true;
        })
            .addCase(exports.invokeRequest.fulfilled, (state, action) => {
            delete state.onGoingRequests[action.meta.requestId];
            state.requestsCache[action.payload.key] = action.payload.body;
            state.isFetching = false;
        })
            .addCase(exports.invokeRequest.rejected, (state, action) => {
            delete state.onGoingRequests[action.meta.requestId];
            if (action.payload) {
                state.requestFail[action.payload.key] = action.payload.error;
            }
            state.isFetching = false;
        });
    }
});
exports.default = exports.requestSlice.reducer;
